<template>
  <v-data-table
    :headers="headers"
    :items="filhos"
    sort-by="nome"
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title class="mr-3">Filhos</v-toolbar-title>
        <v-spacer/>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              v-on="on"
              text
            >Incluir filho</v-btn>
          </template>
          <v-card v-if="dialog">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
					<v-text-field
						v-model="filhoEditado.nome"
						label="Nome"
					/>
					<v-select
						v-model="filhoEditado.paramaconico"
						label="Paramaçônico"
						clearable
						:items="paramaconicos"
					/>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancelar</v-btn>
              <v-btn color="primary" text @click="save">Incluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="() => editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="() => deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue'
import { FilhoMacon } from '@/../common/types/FilhoMacon'
import { paramaconicos } from '@/shareds/sharedsIrmao'

const props = defineProps({
	filhos: {
		type: Array as PropType<FilhoMacon[]>,
		default: () => [],
	},
})

const headers = [
	{
		text: 'Nome',
		align: 'left',
		value: 'nome',
		class: 'text-truncate',
	},
	{ text: 'Paramaçônico', value: 'paramaconico' },
	{ text: 'Ações', value: 'action', sortable: false, width: 80 },
]
const dialog = ref(false)
const editedIndex = ref(-1)
const filhoEditado = ref<FilhoMacon>({
	nome: '',
	paramaconico: undefined,
})
const filhoDefault: FilhoMacon = {
	nome: '',
	paramaconico: undefined,
}

const formTitle = computed(() => editedIndex.value === -1 ? 'Novo Filho' : 'Editar Filho')

function editItem(item: FilhoMacon) {
	editedIndex.value = props.filhos.indexOf(item)
	filhoEditado.value = Object.assign({}, item)
	dialog.value = true
}

function deleteItem(item: FilhoMacon) {
	const index = props.filhos.indexOf(item)
	if (!window.confirm(`Deseja mesmo remover ${item.nome}?`)) return
	props.filhos.splice(index, 1)
}

function close() {
	dialog.value = false
	setTimeout(() => {
		filhoEditado.value = Object.assign({}, filhoDefault)
		editedIndex.value = -1
	}, 300)
}

function save() {
	if (editedIndex.value > -1) {
		Object.assign(props.filhos[editedIndex.value], filhoEditado.value)
	} else {
		props.filhos.push(filhoEditado.value)
	}
	close()
}
</script>
